export default "__VITE_ASSET__9e16ea06__"